import SignOutSvg from "@/icons/sign-out.svg";
import { useDisconnectWallet } from "@/modules/shared/hooks/use-disconnect-wallet";

import "./disconnect-wallet-button.scss";

const DisconnectWalletButton = () => {
  const { disconnectWallet, isDisconnectingWallet } = useDisconnectWallet();

  if (import.meta.env.VITE_DEBUG !== "true") return null;

  return (
    <button
      className="disconnect-wallet-button"
      disabled={isDisconnectingWallet}
      onClick={disconnectWallet}
    >
      <SignOutSvg />
    </button>
  );
};

export { DisconnectWalletButton };
